export default __webpack_public_path__ + "static/media/pro_2025.f2f6df3a.jpg";